import { Image } from 'expo-image';
import React from 'react';
import { View } from 'react-native';

import { AppText } from '@/components/ui/AppText';

const SIZES = { xs: 16, sm: 22, md: 32, lg: 48, xl: 64 } as const;
export type CrestSize = keyof typeof SIZES;

/** Team/competition crest with an initials fallback - never a broken image. */
export function TeamCrest({
  uri,
  name,
  size = 'md',
}: {
  uri: string | null | undefined;
  name: string;
  size?: CrestSize;
}) {
  const pixels = SIZES[size];
  if (!uri) {
    const initials = name
      .split(/\s+/)
      .slice(0, 2)
      .map((word) => word.charAt(0))
      .join('')
      .toUpperCase();
    return (
      <View
        className="items-center justify-center rounded-full bg-surface-2"
        style={{ width: pixels, height: pixels }}
      >
        <AppText variant="micro" weight="bold" className="text-muted">
          {initials}
        </AppText>
      </View>
    );
  }
  return (
    <Image
      source={{ uri }}
      style={{ width: pixels, height: pixels }}
      contentFit="contain"
      transition={150}
      cachePolicy="memory-disk"
      accessibilityLabel={name}
    />
  );
}
